import { Bootgrid } from '../bootgrid';
import { BootgridState, ColumnSearch, SortColumn } from './viewManagerTypes';

export class BootgridStateConstructor {
    private BootgridElement: HTMLTableElement;
    private $bootgrid: JQuery<HTMLElement>;
    private bootgrid: Bootgrid;

    constructor(bootgrid: Bootgrid) {
        this.bootgrid = bootgrid;
        this.BootgridElement = this.bootgrid.container.querySelector('.luscinia-bootgrid');
        this.$bootgrid = $(this.BootgridElement);
    }

    public constructBootgridState(): BootgridState {
        return {
            BootgridId: this.getBootgridId(),
            SelectedGridViewId: this.bootgrid.viewManager.getSelectedViewId(),
            VisibleColumnIds: this.getVisibleColumns(),
            IsAdvancedSearchCollapsed: this.isAdvancedSearchCollapsed(),
            IsColumnSearchCollapsed: (this.$bootgrid as any).bootgrid('getColumnSearchCollapsed') ?? true,
            RowDisplayCount: (this.$bootgrid as any).bootgrid('getRowCount'),
            SelectedSubTableId: this.getSelectedSubTableId(),
            ColumnSearches: this.getColumnSearches(),
            SortColumn: this.getSortColumn(),
            AdvancedFilters: this.bootgrid.advancedFilterManager.getColumnFilters(),
            SelectedRowId: this.getSelectedRowId(),
            CurrentPage: (this.$bootgrid as any).bootgrid('getCurrentPage'),
        };
    }
    private isAdvancedSearchCollapsed(): boolean {
        return this.bootgrid.advancedFilterManagerContainer.classList.contains('hidden');
    }
    private getSortColumn(): SortColumn {
        const sortColumn = this.bootgrid.getColumnSort();

        return Object.entries(sortColumn).map(([columnId, sortDirection]) => ({
            ColumnDataId: columnId,
            SortDirection: sortDirection,
        }))[0];
    }
    private getColumnSearches(): ColumnSearch[] {
        let columnSearches: ColumnSearch[] = [];

        const columnSearchElements = this.BootgridElement.querySelectorAll('thead th:not([data-column-id="commands"])');
        columnSearchElements.forEach((columnSearchElement) => {
            const columnSearchInput = columnSearchElement.querySelector('input') as HTMLInputElement;
            if (columnSearchInput !== null) {
                if (columnSearchInput.value) {
                    columnSearches.push({
                        ColumnDataId: columnSearchElement.getAttribute('data-column-id'),
                        SearchValue: columnSearchInput.value,
                    });
                }
            }
        });
        return columnSearches;
    }
    private getSelectedSubTableId(): string {
        const bottomTabContainer = document.getElementById('bottomTabContainer');
        if (bottomTabContainer === null) {
            return null;
        }
        const subTablesContainer = bottomTabContainer.parentNode;
        const activeSubTableContainer = subTablesContainer.querySelector('.table-container.active');
        return activeSubTableContainer.querySelector('table').getAttribute('data-menu-item-name');
    }
    private getVisibleColumns(): string[] {
        const columnSettings = (this.$bootgrid as any).bootgrid('getColumnSettings');
        let visibleColumns: string[] = [];
        for (let i = 0; i < columnSettings.length; i++) {
            if (columnSettings[i].visible) {
                if (columnSettings[i].id === 'commands') {
                    continue;
                }
                visibleColumns.push(columnSettings[i].id);
            }
        }
        return visibleColumns;
    }
    private getBootgridId(): string {
        return this.BootgridElement.getAttribute('data-menu-item-name');
    }
    private getSelectedRowId(): string {
        return this.$bootgrid.find('tr.row_selected').data('row-id');
    }
}
